export async function hardResetRedux() {
  const { store, persistor } = await import('@app/store');
  const { resetStore } = await import('@app/store/actions/resetStore');
  const { apiSlices } = await import('@app/store/rtkQuery');

  sessionStorage.clear();

  apiSlices.forEach((api) => {
    store.dispatch(api.util.resetApiState());
  });

  store.dispatch(resetStore());

  await persistor.flush();
  await persistor.purge();
}
